import { render, staticRenderFns } from "./enrollmentCreate.vue?vue&type=template&id=1972369b&scoped=true&lang=html&"
import script from "./enrollmentCreate.vue?vue&type=script&lang=js&"
export * from "./enrollmentCreate.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentCreate.vue?vue&type=style&index=0&id=1972369b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972369b",
  null
  
)

export default component.exports